import { TextareaAutosize } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

const RegularTextArea = styled(TextareaAutosize)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(0),
  },
  '&': {
    borderRadius: 10,
    position: 'relative',
    backgroundColor: theme.palette.mode === 'light' ? '#fcfcfb' : '#111633',
    border: '1px solid #484c63',
    fontSize: 16,
    padding: '10px 12px !important',
    transition: theme.transitions.create([
      'border-color',
      'background-color',
      'box-shadow',
    ]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover' : {
      borderColor: '#cbccd280'
    },
    '&:focus': {
      padding: "9px 11px !important",
      borderColor: theme.palette.primary.main,
      borderWidth: 2,
    },
    '&:focus-visible': {
        outline: 'none'
      },
  },
}));

export default RegularTextArea;